









import './scss/BaseRespondsCounter.scss';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const NSProjectResponds = namespace('storeProjectResponds');

@Component({
    name: 'BaseRespondsCounter',
})
export default class BaseRespondsCounter extends Vue {
    @NSProjectResponds.Getter('respondsCount') counter!: number;

    STORAGE_KEY: string = 'RESPONDS_COUNT';
    isCounterChanged: boolean = false;

    get counterDelta(): number {
        const savedCounter = localStorage.getItem(this.STORAGE_KEY);
        return this.counter - Number(savedCounter);
    }

    created() {
        this.checkCounterInStorage();
        if (!!this.counterDelta) this.updateCounter();
    }

    checkCounterInStorage(): void {
        const counter = localStorage.getItem(this.STORAGE_KEY);
        if (!counter) this.saveActualCounterInStorage();
    }

    saveActualCounterInStorage(): void {
        localStorage.setItem(this.STORAGE_KEY, String(this.counter));
    }

    updateCounter() {
        this.isCounterChanged = true;
        this.saveActualCounterInStorage();
    }
}
